module.exports = __webpack_public_path__ + "static/img/fengxiang.0d4644b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fengxiang.png
// module id = 4PeY
// module chunks = 1